import "@arco-design/web-react/es/Trigger/style";
import _Trigger from "@arco-design/web-react/es/Trigger";
import "@arco-design/web-react/es/Badge/style";
import _Badge from "@arco-design/web-react/es/Badge";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Tabs/style";
import _Tabs from "@arco-design/web-react/es/Tabs";
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useLocale from '../../utils/useLocale';
import { getMyTodo } from '@/services';
import { useModal } from '@/context/ModalContext';
import MessageList from './list';
import styles from './style/index.module.less';
function DropContent({
  data,
  loading,
  onClose
}) {
  const t = useLocale();
  const {
    open
  } = useModal();
  function handleItemClick(item) {
    open({
      mode: 'approve',
      type: item.type,
      nodeId: item.nodeId,
      instanceId: item.instanceId,
      formCode: item.formCode,
      bizId: item.bizId
    });
    onClose?.();
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['message-box']
  }, /*#__PURE__*/React.createElement(_Spin, {
    loading: loading,
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement(_Tabs, {
    overflow: "dropdown",
    type: "rounded",
    defaultActiveTab: "todo",
    destroyOnHide: true
  }, /*#__PURE__*/React.createElement(_Tabs.TabPane, {
    key: "todo",
    title: /*#__PURE__*/React.createElement("span", null, t['message.tab.title.todo'], data.length ? `(${data.length})` : '')
  }, /*#__PURE__*/React.createElement(MessageList, {
    data: data,
    onItemClick: handleItemClick,
    onMoreClick: onClose
  })))));
}
function MessageBox({
  children
}) {
  const userInfo = useSelector(state => state.userInfo);
  const userId = userInfo?.userId || '';
  // 审批成功后 ModalContext 会自增 refreshKey，监听它同步刷新待办角标与下拉列表
  const {
    refreshKey
  } = useModal();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sourceData, setSourceData] = useState([]);
  const [total, setTotal] = useState(0);

  // 待办数据来源与「待办列表」页一致：getMyTodo
  const fetchSourceData = useCallback((showLoading = true) => {
    if (!userId) {
      setSourceData([]);
      setTotal(0);
      return;
    }
    showLoading && setLoading(true);
    getMyTodo(userId, 1, 5, {}).then(res => {
      setTotal(res.totalRow || 0);
      setSourceData((res.list || []).map(task => ({
        id: task.id,
        type: task.type,
        title: task.instanceTitle || '-',
        subTitle: task.nodeName,
        startTime: task.createDate,
        nodeId: task.nodeId,
        instanceId: task.instanceId,
        bizId: task.bizId,
        formCode: task.formData?.formCode
      })));
    }).finally(() => {
      showLoading && setLoading(false);
    });
  }, [userId]);
  useEffect(() => {
    fetchSourceData(false);
  }, [fetchSourceData, refreshKey]);

  // 打开弹层时刷新一次，保证角标和列表是最新的
  const handleVisibleChange = nextVisible => {
    setVisible(nextVisible);
    if (nextVisible) {
      fetchSourceData(false);
    }
  };
  return /*#__PURE__*/React.createElement(_Trigger, {
    trigger: "click",
    popup: () => /*#__PURE__*/React.createElement(DropContent, {
      data: sourceData,
      loading: loading,
      onClose: () => setVisible(false)
    }),
    position: "br",
    unmountOnExit: false,
    popupAlign: {
      bottom: 4
    },
    popupVisible: visible,
    onVisibleChange: handleVisibleChange
  }, /*#__PURE__*/React.createElement(_Badge, {
    count: total,
    maxCount: 99
  }, children));
}
export default MessageBox;